{
    "DocumentViewer_AcceptButton": "Accettare",
    "DocumentViewer_CloseButton": "Vicino",
    "NAME": "DocumentViewer"
}